module.exports = __webpack_public_path__ + "img/Card View.aa20e270.svg";